var $ = require('jquery');
var ViewportTracker = require('../lib/ViewportTracker.js');
var MainMenu = require('../site/MainMenu.js');
var Animation = require('../lib/Animation.js');

function setupFilters(blockName) {
	makeSticky(blockName);
	makeAccordion(blockName);
}

function makeSticky(blockName) {
	var $filters = $('.' + blockName);
	
	if ($filters.length === 0)
		return;
	
	var stuckStyleClass = blockName + '--stuck';
	var filterStuck = undefined;
	var triggerPointFiltersSticky;
	
	var $header__bottomContainer = $('.header__bottomContainer');
	
	var $filtersButton = $filters.find('button');
	var $filtersInner = $filters.find('.' + blockName + '__inner');
	var $filtersButtonInHeader = $filtersButton.clone();
	var $headerFilters = $('<div class="' + blockName + ' ' + blockName + '--inHeader"/>').appendTo($header__bottomContainer);
	$headerFilters.append($filtersButtonInHeader);
	$header__bottomContainer.append($headerFilters);
	
	function animationSetup() {
		var buttonHeight = $filtersButton.outerHeight();
		triggerPointFiltersSticky = $filters.offset().top + buttonHeight;
		filterStuck = undefined;
		
		var stickyFiltersArea = new Animation.AreaCustom('mobile header sticky animation', function(value, manager) {
				var currTriggerPointFiltersSticky = triggerPointFiltersSticky;
				if (MainMenu.isMenuVisible()) {
					currTriggerPointFiltersSticky -= MainMenu.getHeaderHeight()
				}
				if (value >= currTriggerPointFiltersSticky) {
					return 1;
				}
				
				return 0;
			},
			[
			 new Animation.StyleClass($filters, stuckStyleClass),
			 new Animation.StyleClass($headerFilters, stuckStyleClass),
			 new Animation.CustomHandler(function(percentage, area) {
				 // Update
				 if (percentage >= 1) {
					// Put in header
					 if (filterStuck !== true) {
						filterStuck = true;
						$filtersInner.appendTo($headerFilters);
					}
				 } else {
					 if (filterStuck === true) {
						filterStuck = false;
						$filtersInner.appendTo($filters);
					 }
				 }
			 }, function(area) {
				 // Reset
				 $filtersInner.appendTo($filters);
				 filterStuck = undefined;
			 })
			]
		);
		manager.addArea(stickyFiltersArea);
		
	}
	
	var manager = Animation.Manager.getInstance('scroll--mobile');
	manager.addSetup(animationSetup);
}

function makeAccordion(blockName) {
	var $allFilters = $('.' + blockName);
	var $elementsTriggerToggle = $('.' + blockName + ' button, .' + blockName + '__overlay');
	
	function filterToggleView(event) {
		event.preventDefault();
		
		var toggleValue = $allFilters.attr('aria-expanded') == 'true' ? 'false' : 'true';
		$allFilters.attr('aria-expanded', toggleValue);
	}
	function onViewportState() {
		var state = ViewportTracker.getState();
		
		if (state == 'mobile') {
			// Turn off
			$allFilters.attr('aria-expanded', 'false');
			$elementsTriggerToggle.on('click.filterToggle', filterToggleView);
		} else {
			// Turn on
			$allFilters.attr('aria-expanded', 'false');
			$allFilters.removeAttr('aria-expanded');
			$elementsTriggerToggle.off('click.filterToggle');
		}
	}
	$(window).on('ViewportTracker:state', onViewportState);
}

module.exports = setupFilters;